// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-deinition-screen h1 {
  margin-bottom: 20px;
}

.new-role-container {
  background-color: var(--container-background-color);
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 10px;
}
.new-role-container .css-b62m3t-container {
  position: relative;
  box-sizing: border-box;
  width: 100%;
}
.new-role-container .ag-theme-quartz .ag-header,
.new-role-container .ag-theme-quartz .ag-advanced-filter-header {
  background-color: #ebebeb !important;
}

.new-role-title {
  align-items: center;
  color: var(--title-container-text);
  font-size: 14px;
  font-weight: 500;
  font-family: "ABBVoice-medium";
  background-color: var(--title-container-background);
  margin: 2px;
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.new-role-content-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 10px;
}

.new-role-label {
  color: var(--label-color);
  font-family: "ABBVoice-regular";
  font-size: 12px;
  font-weight: 600;
  min-width: 160px;
}

.new-role-input {
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 8px;
  flex: 1 0;
  width: 100%;
  max-width: 300px;
  height: 34px;
  border: 1px solid #cacaca;
  border-radius: 5px;
}

.new-role-input[type=text]:focus {
  outline: none;
  border: 2px solid #4168ff;
}

.new-role-input:disabled {
  background-color: #f5f5f5 !important;
  cursor: not-allowed !important;
}

.new-role-checkbox {
  display: flex;
  flex-direction: row;
}

.new-role-content-section {
  display: flex;
  margin-top: 2%;
}
.new-role-content-section .input-wrapper {
  width: 240px;
}
.new-role-content-section .css-15g569d-control {
  min-height: 34px !important;
  min-width: 100% !important;
  border-color: var(--input-field-border-color) !important;
  border-radius: 4px !important;
  border-width: 1px !important;
  font-size: 12px;
  background-color: var(--dropdown-background-color);
}
.new-role-content-section .error-message {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.new-role-content-section .ABB_CommonUX_Dropdown__root {
  max-width: 300px;
  height: 34px;
}
.new-role-content-section .ABB_CommonUX_Dropdown__comp {
  width: 240px;
}
.new-role-content-section .new-role-label {
  display: flex;
  align-items: center;
  min-width: 140px;
}
.new-role-content-section [role=option] {
  font-size: 12px !important;
}

.role-dropdown-row_c {
  font-family: "ABBVoice-regular";
  font-size: small;
  border: 2px solid #cacaca;
  outline: none;
  width: 450px;
  height: 40px;
  border-radius: 5px;
}

.role-checkbox {
  width: 3%;
}

.new-role-definition-input-group-button {
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: flex-end;
  margin-top: auto;
  margin-bottom: 20px;
  margin-right: 20px;
}

.formik-error {
  display: flex;
  color: #ff000f;
}

.asterisk {
  color: rgb(217, 83, 79);
  font-size: 18px;
  font-family: "ABBVoice-regular" -bold;
}

.new-role-alert-success {
  color: green;
}

.new-role-alert-fail {
  color: #ff000f;
}

.content-container h1 {
  position: relative !important;
  font-size: 16px !important;
  margin-top: 25px !important;
  text-transform: capitalize !important;
  font-family: "ABBVoice-regular";
  margin-bottom: 20px;
}

.css-ht7ws5 {
  color: var(input-text-color);
  height: 16px;
  line-height: 16px;
  width: 0;
  margin-top: 1px;
  grid-row: 1;
  grid-column: 1;
}

.MuiButtonBase-root.MuiButton-root .label {
  font-size: 0.875rem;
  text-wrap: nowrap;
  font-weight: 500;
  font-family: "ABBVoice", Verdana;
  color: var(--btn-text-color) !important;
}

.css-xp6xt7 {
  max-width: calc(100% - 8px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
  color: var(--input-text-color) !important;
  grid-row: 1;
  grid-column: 1;
}

.css-15g569d-control:hover {
  background: var(--dropdown-background-color-hover) !important;
  border-color: #9f9f9f;
}

.css-111g279-menu {
  background: green !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/new_role.scss"],"names":[],"mappings":"AAGE;EACE,mBAAA;AAFJ;;AAKA;EACE,mDAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAFF;AAGE;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;AADJ;AAGE;;EAEE,oCAAA;AADJ;;AAIA;EACE,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mDAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AADF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;AAAF;;AAEA;EACE,yBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,aAAA;EACA,yBAAA;AAGF;;AADA;EACE,oCAAA;EACA,8BAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,cAAA;AAIF;AAHE;EACE,YAAA;AAKJ;AAHE;EACE,2BAAA;EACA,0BAAA;EACA,wDAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kDAAA;AAKJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAKJ;AAHE;EACE,gBAAA;EACA,YAAA;AAKJ;AAHE;EACE,YAAA;AAKJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAKJ;AAFE;EACE,0BAAA;AAIJ;;AADA;EACE,+BAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAIF;;AAFA;EACE,SAAA;AAKF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,aAAA;EACA,cAAA;AAOF;;AALA;EACE,uBAAA;EACA,eAAA;EACA,qCAAA;AAQF;;AANA;EACE,YAAA;AASF;;AAPA;EACE,cAAA;AAUF;;AAPA;EACE,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+BAAA;EACA,mBAAA;AAUF;;AARA;EACE,4BAAA;EACA,YAAA;EACA,iBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAWF;;AARA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,uCAAA;AAWF;;AATA;EACE,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yCAAA;EACA,WAAA;EACA,cAAA;AAYF;;AATA;EACE,6DAAA;EACA,qBAAA;AAYF;;AATA;EACE,4BAAA;AAYF","sourcesContent":["@import \"../../assets/variables/fonts.scss\";\r\n\r\n.role-deinition-screen {\r\n  h1 {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n.new-role-container {\r\n  background-color: var(--container-background-color);\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  border-radius: 10px;\r\n  .css-b62m3t-container {\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n  }\r\n  .ag-theme-quartz .ag-header,\r\n  .ag-theme-quartz .ag-advanced-filter-header {\r\n    background-color: #ebebeb !important;\r\n  }\r\n}\r\n.new-role-title {\r\n  align-items: center;\r\n  color: var(--title-container-text);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-family: \"ABBVoice-medium\";\r\n  background-color: var(--title-container-background);\r\n  margin: 2px;\r\n  padding: 4px 10px;\r\n  border-top-right-radius: 8px;\r\n  border-top-left-radius: 8px;\r\n}\r\n.new-role-content-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  gap: 10px;\r\n}\r\n.new-role-label {\r\n  color: var(--label-color);\r\n  font-family: \"ABBVoice-regular\";\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  min-width: 160px;\r\n}\r\n.new-role-input {\r\n  display: flex;\r\n  padding: 12px;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 1 0 0;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  height: 34px;\r\n  border: 1px solid #cacaca;\r\n  border-radius: 5px;\r\n}\r\n.new-role-input[type=\"text\"]:focus {\r\n  outline: none;\r\n  border: 2px solid #4168ff;\r\n}\r\n.new-role-input:disabled {\r\n  background-color: #f5f5f5 !important;\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.new-role-checkbox {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.new-role-content-section {\r\n  display: flex;\r\n  margin-top: 2%;\r\n  .input-wrapper {\r\n    width: 240px;\r\n  }\r\n  .css-15g569d-control {\r\n    min-height: 34px !important;\r\n    min-width: 100% !important;\r\n    border-color: var(--input-field-border-color) !important;\r\n    border-radius: 4px !important;\r\n    border-width: 1px !important;\r\n    font-size: 12px;\r\n    background-color: var(--dropdown-background-color);\r\n  }\r\n  .error-message {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-left: 8px;\r\n  }\r\n  .ABB_CommonUX_Dropdown__root {\r\n    max-width: 300px;\r\n    height: 34px;\r\n  }\r\n  .ABB_CommonUX_Dropdown__comp {\r\n    width: 240px;\r\n  }\r\n  .new-role-label {\r\n    display: flex;\r\n    align-items: center;\r\n    min-width: 140px;\r\n  }\r\n\r\n  [role=\"option\"] {\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n.role-dropdown-row_c {\r\n  font-family: \"ABBVoice-regular\";\r\n  font-size: small;\r\n  border: 2px solid #cacaca;\r\n  outline: none;\r\n  width: 450px;\r\n  height: 40px;\r\n  border-radius: 5px;\r\n}\r\n.role-checkbox {\r\n  width: 3%;\r\n}\r\n.new-role-definition-input-group-button {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 15px;\r\n  justify-content: flex-end;\r\n  margin-top: auto;\r\n  margin-bottom: 20px;\r\n  margin-right: 20px;\r\n}\r\n.formik-error {\r\n  display: flex;\r\n  color: #ff000f;\r\n}\r\n.asterisk {\r\n  color: rgb(217, 83, 79);\r\n  font-size: 18px;\r\n  font-family: \"ABBVoice-regular\"-bold;\r\n}\r\n.new-role-alert-success {\r\n  color: green;\r\n}\r\n.new-role-alert-fail {\r\n  color: #ff000f;\r\n}\r\n\r\n.content-container h1 {\r\n  position: relative !important;\r\n  font-size: 16px !important;\r\n  margin-top: 25px !important;\r\n  text-transform: capitalize !important;\r\n  font-family: \"ABBVoice-regular\";\r\n  margin-bottom: 20px;\r\n}\r\n.css-ht7ws5 {\r\n  color: var(input-text-color);\r\n  height: 16px;\r\n  line-height: 16px;\r\n  width: 0;\r\n  margin-top: 1px;\r\n  grid-row: 1;\r\n  grid-column: 1;\r\n}\r\n\r\n.MuiButtonBase-root.MuiButton-root .label {\r\n  font-size: 0.875rem;\r\n  text-wrap: nowrap;\r\n  font-weight: 500;\r\n  font-family: \"ABBVoice\", Verdana;\r\n  color: var(--btn-text-color)!important;\r\n}\r\n.css-xp6xt7 {\r\n  max-width: calc(100% - 8px);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: pre;\r\n  color: var(--input-text-color) !important;\r\n  grid-row: 1;\r\n  grid-column: 1;\r\n}\r\n\r\n.css-15g569d-control:hover {\r\n  background: var(--dropdown-background-color-hover) !important;\r\n  border-color: #9f9f9f;\r\n}\r\n\r\n.css-111g279-menu{\r\n  background: green !important;\r\n}\r\n// background-color: #ff000f !important;\r\n// color: greenyellow !important;\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
